import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import Heading from "../ui/Heading";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";
import design1 from '../../../../../Assets/images/custom-design1.png'
import design2 from '../../../../../Assets/images/custom-design2.png'
import dividerLine from '../../../../../Assets/images/divider-line.png'


const Webuy = () => {
  return (
    <>
 
    <Image src={dividerLine} className="img-fluid w-100 m-auto"/>
    <section className="custom-design Webuy_section">
      
      <Container fluid>
        <Row className="align-items-center">
          <Col md={4} xs={12} className="text-center">
            <Image src={design1} alt="Custom Design Jewelry " className="w-100 m-auto  h-auto" />
          </Col>

          <Col md={4} xs={12}>
            <Heading>
              {/* <span className="text-uppercase">Be the Designer</span> */}
              <h2 className="text-uppercase">Custom <br></br> Design {Je_welryspelling} </h2>
              {/* <p>
                Indulge in the luxury of self-expression with our custom design {Je_welryspelling}  service. From intricate details to personalized  touches, each piece is crafted to reflect your unique style and story. Elevate your look with bespoke treasures that are asexceptional as you are.
              </p> */}
              <p>Custom {Je_welryspelling} is a testament to personal
style and individuality, where dreams are
transformed into wearable art.</p>
            </Heading>

            <div className="text-center">
              <Link to="/custom-design" className="btn outline-base-btn large ">  
                Get Started
              </Link>
            </div>
          </Col>
          <Col md={4} xs={12} className="text-center p-lg-0 p-md-0 ">
            <Image src={design2} alt="Custom Design Jewelry " className="w-100 h-auto m-auto" />
          </Col>

        </Row>
      </Container>
    </section>
       </>
  );
};

export default Webuy;
